"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertKeyValuePairsIntoObject = exports.convertObjectIntoKeyValuePairs = exports.getMeResultMatrixIterationResult = exports.getMeResultCustomFieldResult = exports.getMeResultFieldResult = exports.getMeResultNoResult = exports.getOptionsLabel = exports.getOptionKey = exports.getSafeOptionKeyArray = exports.getSafeOptionKey = exports.getSafeValueOrReturn = exports.getSafeValue = void 0;
const lodash_1 = __importDefault(require("lodash"));
const types_1 = require("../../types");
const getSafeValue = (object, key) => {
    return (0, exports.getSafeValueOrReturn)(object, key, undefined);
};
exports.getSafeValue = getSafeValue;
const getSafeValueOrReturn = (object, key, returnVal) => {
    if (!key || !object)
        return returnVal;
    return lodash_1.default.get(object, key, returnVal);
};
exports.getSafeValueOrReturn = getSafeValueOrReturn;
const getSafeOptionKey = (value) => {
    if (value && lodash_1.default.isObject(value)) {
        return (0, exports.getOptionKey)(value);
    }
    return value;
};
exports.getSafeOptionKey = getSafeOptionKey;
const getSafeOptionKeyArray = (value) => {
    if (value && Array.isArray(value)) {
        const result = [];
        value.forEach((item) => {
            result.push((0, exports.getSafeOptionKey)(item));
        });
        return result;
    }
    else if (value && typeof value === "object") {
        return lodash_1.default.map(value, exports.getSafeOptionKey);
    }
    else {
        return undefined;
    }
};
exports.getSafeOptionKeyArray = getSafeOptionKeyArray;
const getOptionKey = (option) => option === null || option === void 0 ? void 0 : option.key;
exports.getOptionKey = getOptionKey;
const getOptionsLabel = ({ schema, key, metaExpression, }) => {
    var _a;
    const questionSchema = schema === null || schema === void 0 ? void 0 : schema.find((si) => [si.tag, si.column_tag].includes(metaExpression.custom_field1));
    const option = lodash_1.default.find((_a = questionSchema === null || questionSchema === void 0 ? void 0 : questionSchema.otherProps) === null || _a === void 0 ? void 0 : _a.options, {
        key,
    });
    const label = option === null || option === void 0 ? void 0 : option.value;
    return label || key;
};
exports.getOptionsLabel = getOptionsLabel;
const getMeResultNoResult = () => {
    return {
        type: types_1.ME_RESULT_TYPE.NO_RESULT,
        result: undefined,
    };
};
exports.getMeResultNoResult = getMeResultNoResult;
const getMeResultFieldResult = (result) => {
    return {
        type: types_1.ME_RESULT_TYPE.FIELD_RESULT,
        result,
    };
};
exports.getMeResultFieldResult = getMeResultFieldResult;
const getMeResultCustomFieldResult = (result) => {
    return {
        type: types_1.ME_RESULT_TYPE.CUSTOM_FIELD_RESULT,
        result: result,
    };
};
exports.getMeResultCustomFieldResult = getMeResultCustomFieldResult;
const getMeResultMatrixIterationResult = (result) => {
    return {
        type: types_1.ME_RESULT_TYPE.MATRIX_ITERATION_RESULT,
        result: result,
    };
};
exports.getMeResultMatrixIterationResult = getMeResultMatrixIterationResult;
const convertObjectIntoKeyValuePairs = (item) => {
    return Object.entries(item).map(([key, value]) => ({
        key,
        value,
    }));
};
exports.convertObjectIntoKeyValuePairs = convertObjectIntoKeyValuePairs;
const convertKeyValuePairsIntoObject = (arr) => {
    return arr.reduce((accumulator, currentItem) => {
        accumulator[currentItem.key] = currentItem.value;
        return accumulator;
    }, {});
};
exports.convertKeyValuePairsIntoObject = convertKeyValuePairsIntoObject;
